<template>
  <div>
    <div
      class="comment_other_actions hidden"
      ref="other_action"
      :style="{ position: 'fixed' }"
    >
      <span
        class="other_action error_send"
        @click="error_send(selectedMessage)"
        v-if="error"
      >
        {{ $t("comment.menu.resend") }}
      </span>
      <span
        v-if="
          selectedMessage &&
          selectedMessage.user_id == getUserData._id &&
          !error &&
          !hasFile
        "
        class="other_action"
        @click="edit_message(selectedMessage)"
      >
        {{ $t("comment.menu.edit") }}
      </span>
      <span
        class="other_action"
        @click="reply_message(selectedMessage)"
        v-if="!error"
      >
        {{ $t("comment.menu.reply") }}
      </span>
      <span class="other_action" @click="copy_message(selectedMessage)">
        {{ $t("comment.menu.copy") }}
      </span>
      <span
        class="other_action red"
        v-if="selectedMessage && selectedMessage.user_id == getUserData._id"
        @click="delete_message(selectedMessage)"
      >
        {{ $t("comment.menu.delete") }}
      </span>
      <div
        :class="
          users.length == 1 ? 'users_lists__read' : 'users_lists__read hover'
        "
        v-if="
          comment &&
          comment.task_id &&
          users.length > 0 &&
          getPlan.show_who_read_message == 'on'
        "
        @mouseover="show_users_lists = true"
        @mouseleave="show_users_lists = false"
      >
        <p v-if="users.length > 1" class="users_lists__text">
          {{ users.length }} {{ $t("comment.menu.seen") }}
        </p>
        <p v-else class="users_lists__text" style="width: 100px">
          {{
            users[0] == getUserData._id
              ? $t("comment.menu.you")
              : get_user(users[0]).name
          }}
        </p>
        <ul>
          <li
            v-for="user of users.slice(0, 3)"
            :key="user"
            :style="`background-color: ${get_user(user).color}`"
            :title="get_user(user).name"
            v-html="$w_user_image(get_user(user), 70, false, 'task')"
          ></li>
        </ul>
      </div>
      <div
        class="users_lists__read blur"
        @click="alertUpgradePlan"
        v-if="
          comment && comment.task_id && getPlan.show_who_read_message == 'off'
        "
      >
        <div></div>
        <p class="users_lists__text">{{ $t("comment.menu.three_seen") }}</p>
        <ul>
          <li
            v-for="user of fake_users"
            :key="user.id"
            :style="`background-color: ${user.color}`"
            :title="user.name"
          >
            <span>{{ user.name[0] }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="users_lists__read__lists comment_other_actions"
      ref="users_lists"
      :style="users_lists__style()"
      @mouseover="show_users_lists = true"
      @mouseleave="show_users_lists = false"
    >
      <ul>
        <li v-for="user of users" :key="user + 1">
          <div
            :style="`background-color: ${get_user(user).color}`"
            v-html="$w_user_image(get_user(user), 70, false, 'task')"
          ></div>
          <p>
            {{
              user == getUserData._id
                ? $t("comment.menu.you")
                : get_user(user).name
            }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import File from "../../utils/aws";
import { EventEmitter } from "../../main";

export default {
  name: "ChatOtherAction",
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      selectedMessage: null,
      edit: "",
      reply: "",
      error: false,
      hasFile: false,
      users: [],
      show_users_lists: false,
      comment: {},
      fake_users: [
        {
          id: 1,
          name: "Bred",
          color: "#f2a7a7",
        },
        {
          id: 2,
          name: "Dave",
          color: "#e3b5b5",
        },
        {
          id: 3,
          name: "Riley",
          color: "#e8cca2",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("click", () => {
      this.show_users_lists = false;
      if (document.querySelector(".right_sidebar")) {
        document.querySelector(".right_sidebar").style.overflow = "hidden";
        document.querySelector(
          ".right_sidebar .el-tabs__content"
        ).style.overflow = "hidden";
      }
      this.$root.$emit("selectMessage", { comment: null, position: null });
    });

    this.$root.$on("selectMessage", ({ comment, position = null }) => {
      this.show_popup(comment, position);
      this.comment = comment;
      this.users = [];
      if (comment) {
        if (this.getTasks[this.$route.params.project_id]) {
          if (
            this.getTasks[this.$route.params.project_id].some(
              (t) => t._id == this.$route.params.task_id
            )
          ) {
            this.getTasks[this.$route.params.project_id]
              .find((e) => e._id == this.$route.params.task_id)
              .users.forEach((e, i) => {
                if (e.read_last_message) {
                  let msg = this.getComments[this.$route.params.task_id].find(
                    (a) => a._id == e.read_last_message
                  );
                  if (msg.date >= comment.date) {
                    if (comment.user_id != e._id) {
                      this.users.push(e._id);
                    }
                  }
                }
              });
          }
        }

        if (this.getCompletedTasks[this.$route.params.project_id]) {
          if (
            this.getCompletedTasks[this.$route.params.project_id].some(
              (t) => t._id == this.$route.params.task_id
            )
          ) {
            this.getCompletedTasks[this.$route.params.project_id]
              .find((e) => e._id == this.$route.params.task_id)
              .users.forEach((e, i) => {
                if (e.read_last_message) {
                  let msg = this.getComments[this.$route.params.task_id].find(
                    (a) => a._id == e.read_last_message
                  );
                  if (msg.date >= comment.date) {
                    if (comment.user_id != e._id) {
                      this.users.push(e._id);
                    }
                  }
                }
              });
          }
        }
      }
    });
  },
  methods: {
    ...mapActions(["socket_delete_message", "socket_repead_send"]),
    ...mapMutations([
      "set_new_local_reply_message",
      "change_flag_for_reply_message",
      "set_new_local_edit_message",
      "change_flag_for_edit_message",
      "delete_local_edit_message",
      "delete_local_reply_message",
      "setUserFileSize_minus",
    ]),
    alertUpgradePlan() {
      this.$w_alert(this.$t("comment.messages.need_upgrade_read_unlock"), [
        {
          buttonText: this.$t("app.alert.cancel"),
          callback: (close) => {
            close();
          },
        },
        {
          buttonText: this.$t("app.alert.upgrade"),
          callback: (close) => {
            EventEmitter.$emit("openSettingPlan", true);
            close();
          },
        },
      ]);
    },
    users_lists__style() {
      let style = "";

      if (!this.show_users_lists) {
        style += "z-index: -1;padding: 0";
      } else {
        if (this.users.length == 1) {
          style += "z-index: -1;padding: 0";
        } else {
          style += "z-index: 999999;";
        }
      }

      if (this.type == "chat") {
        style += "position: fixed;";
      }

      return style;
    },
    error_send(comment) {
      this.socket_repead_send(comment._id);
    },
    get_user(user_id) {
      if (this.getUserData._id == user_id) {
        return this.getUserData;
      } else {
        return this.getKnownUsers.find((user) => user._id == user_id);
      }
    },
    reply_message(comment) {
      const id = comment.task_id
        ? "add_comment_block_list"
        : "add_comment_block_chat";
      document.getElementById(id).focus();
      this.reply = comment;

      if (this.edit) {
        this.delete_local_edit_message(this.edit);
        this.change_flag_for_edit_message();
      }

      this.set_new_local_reply_message(comment);
      this.change_flag_for_reply_message();
    },
    edit_message(comment) {
      const id = comment.task_id
        ? "add_comment_block_list"
        : "add_comment_block_chat";
      document.getElementById(id).focus();
      this.edit = comment;

      if (this.reply) {
        this.delete_local_reply_message(this.reply);
        this.change_flag_for_reply_message();
      }

      this.set_new_local_edit_message(comment);
      this.change_flag_for_edit_message();
    },
    delete_message(comment) {
      if (comment.task_id) {
        this.comment_delete_list(comment);
      } else {
        this.comment_delete_chat(comment);
      }
    },
    copy_message(comment) {
      this.$clipboard(comment.message);
    },
    show_popup_delete(callback) {
      let delete_message_popup;

      if (document.querySelector(".custom_message_popup"))
        delete_message_popup = document.querySelector(".custom_message_popup");
      else {
        delete_message_popup = document.createElement("div");
        delete_message_popup.classList.add("custom_message_popup");
        this.$root.$el.insertAdjacentElement("beforeend", delete_message_popup);
      }

      delete_message_popup.innerHTML = "";
      const body = document.createElement("div");
      delete_message_popup.insertAdjacentElement("beforeend", body);
      const title = document.createElement("div");
      title.classList.add("text");
      title.innerHTML = this.$t("comment.messages.delete");
      body.insertAdjacentElement("beforeend", title);
      const call_to_action_footer = document.createElement("div");
      call_to_action_footer.classList.add("call_to_action_footer");
      body.insertAdjacentElement("beforeend", call_to_action_footer);
      const cancel = document.createElement("button");
      cancel.innerHTML = this.$t("app.alert.cancel");
      call_to_action_footer.insertAdjacentElement("beforeend", cancel);
      const confirm = document.createElement("button");
      confirm.classList.add("red");
      confirm.innerHTML = this.$t("app.alert.delete");
      call_to_action_footer.insertAdjacentElement("beforeend", confirm);

      delete_message_popup.classList.add("active");

      cancel.addEventListener("click", (e) => {
        e.preventDefault();
        delete_message_popup.classList.remove("active");
        delete_message_popup.remove();
      });

      confirm.addEventListener("click", (e) => {
        e.preventDefault();
        callback();
        delete_message_popup.classList.remove("active");
        delete_message_popup.remove();
      });
    },
    show_popup(comment, position) {
      this.selectedMessage = null;

      if (this.$refs.other_action) {
        if (comment) {
          this.$refs.other_action.classList.add("active");
          setTimeout(() => {
            this.$refs.other_action.classList.remove("hidden");
          }, 100);
        } else {
          this.$refs.other_action.classList.remove("active");
          this.$refs.other_action.classList.add("hidden");
        }
      }

      this.selectedMessage = comment;
      if (comment) {
        if (document.querySelector(".right_sidebar")) {
          document.querySelector(".right_sidebar").style.overflow = "unset";
          document.querySelector(
            ".right_sidebar .el-tabs__content"
          ).style.overflow = "unset";
        }
        // if (comment.users) {
        //     this.users = comment.users.filter(function(item, pos) {
        //         return comment.users.indexOf(item) == pos;
        //     })
        //     if (comment.user_id == this.getUserData._id) {
        //         this.users = this.users.filter(e => e != this.getUserData._id)
        //     }
        // } else {
        //     this.users = []
        // }
      } else {
        // this.users = []
      }

      if (this.selectedMessage) {
        if (this.selectedMessage.error) {
          this.error = this.selectedMessage.error;
        } else {
          this.error = false;
        }

        if (this.selectedMessage.file_body) {
          if (this.selectedMessage.file_body.length > 0) {
            this.hasFile = true;
          } else {
            if (this.selectedMessage.files) {
              if (this.selectedMessage.files.length > 0) {
                this.hasFile = true;
              } else {
                this.hasFile = false;
              }
            }
          }
        } else {
          if (this.selectedMessage.files) {
            if (this.selectedMessage.files.length > 0) {
              this.hasFile = true;
            } else {
              this.hasFile = false;
            }
          }
        }
      }

      if (position) {
        setTimeout(() => {
          this.$refs.users_lists.style = "";

          this.$refs.other_action.style.top =
            position.mouseY + this.$refs.other_action.clientHeight >
            position.chatWindow.bottom
              ? (this.$refs.other_action.style.top =
                  position.mouseY - this.$refs.other_action.clientHeight + "px")
              : (this.$refs.other_action.style.top = position.mouseY + "px");
          this.$refs.other_action.style.left =
            position.mouseX + this.$refs.other_action.clientWidth >
            position.chatWindow.right
              ? (this.$refs.other_action.style.left =
                  position.mouseX - this.$refs.other_action.clientWidth + "px")
              : (this.$refs.other_action.style.left = position.mouseX + "px");

          let top =
            position.mouseY + this.$refs.other_action.clientHeight >
            position.chatWindow.bottom
              ? (this.$refs.other_action.style.top =
                  position.mouseY - this.$refs.other_action.clientHeight)
              : (this.$refs.other_action.style.top = position.mouseY);
          let left =
            position.mouseX + this.$refs.other_action.clientWidth >
            position.chatWindow.right
              ? (this.$refs.other_action.style.left =
                  position.mouseX - this.$refs.other_action.clientWidth)
              : (this.$refs.other_action.style.left = position.mouseX);
          let block = document.querySelector(".comments");

          if (
            position.mouseY - position.window.height >
            this.$refs.users_lists.clientHeight - 50
          ) {
            this.$refs.users_lists.style.bottom =
              window.innerHeight -
              (this.$refs.other_action.offsetTop +
                this.$refs.other_action.clientHeight) +
              "px";
          } else {
            this.$refs.users_lists.style.top =
              this.$refs.other_action.clientHeight + top - 45 + "px";
          }

          if (left + 345 >= block.clientWidth) {
            this.$refs.users_lists.style.left = left - 170 + "px";
          } else {
            this.$refs.users_lists.style.left =
              left >= 175 ? left - 170 + "px" : left + 170 + "px";
          }
        }, 100);
      }

      // if (comment) {
      //     if (this.type == 'list') {
      //         this.getTasks[this.$route.params.project_id].forEach((task) => {
      //             if (task._id == this.$route.params.task_id) {
      //                 task.users.forEach((user) => {
      //                     if (user.read_last_message == comment._id) {
      //                         if (this.users.length == 0) {
      //                             this.users.push(user)
      //                         } else {
      //                             let is_user = this.users.filter(e => e._id == user._id)
      //                             if (is_user.length == 0) {
      //                                 this.users.push(user)
      //                             }
      //                         }
      //                     }
      //                 })
      //             }
      //         })
      //     }
      // }
    },
    comment_delete_list(comment) {
      const aws = new File();

      if (comment.files) {
        comment.files.forEach((e) => {
          this.setUserFileSize_minus(+e.size);

          if (
            e.ext.toLowerCase() == "png" ||
            e.ext.toLowerCase() == "jpg" ||
            e.ext.toLowerCase() == "jpeg"
          ) {
            if (e.imgWidth > 200) {
              let sizes = [200, "full"];
              sizes.forEach((size) => {
                const remove = aws.remove(
                  "Lists" +
                    "/" +
                    this.$route.params.project_id +
                    "/" +
                    this.$route.params.task_id +
                    "/" +
                    size +
                    "__" +
                    e._id +
                    "__" +
                    e.filename
                );
              });
            } else {
              const remove = aws.remove(
                "Lists" +
                  "/" +
                  this.$route.params.project_id +
                  "/" +
                  this.$route.params.task_id +
                  "/" +
                  e._id +
                  "__" +
                  e.filename
              );
            }
          } else {
            const remove = aws.remove(
              "Lists" +
                "/" +
                this.$route.params.project_id +
                "/" +
                this.$route.params.task_id +
                "/" +
                e._id +
                "__" +
                e.filename
            );
          }
        });
      } else {
        comment.files_body.forEach((e) => {
          this.setUserFileSize_minus(+e.size);

          if (
            e.ext.toLowerCase() == "png" ||
            e.ext.toLowerCase() == "jpg" ||
            e.ext.toLowerCase() == "jpeg"
          ) {
            if (e.imgWidth > 200) {
              let sizes = [200, "full"];
              sizes.forEach((size) => {
                const remove = aws.remove(
                  "Lists" +
                    "/" +
                    this.$route.params.project_id +
                    "/" +
                    this.$route.params.task_id +
                    "/" +
                    size +
                    "__" +
                    e._id +
                    "__" +
                    e.filename
                );
              });
            } else {
              const remove = aws.remove(
                "Lists" +
                  "/" +
                  this.$route.params.project_id +
                  "/" +
                  this.$route.params.task_id +
                  "/" +
                  e._id +
                  "__" +
                  e.filename
              );
            }
          } else {
            const remove = aws.remove(
              "Lists" +
                "/" +
                this.$route.params.project_id +
                "/" +
                this.$route.params.task_id +
                "/" +
                e._id +
                "__" +
                e.filename
            );
          }
        });
      }

      this.$w_alert(this.$t("comment.messages.delete"), [
        {
          buttonText: this.$t("app.alert.cancel"),
          callback: (close) => {
            close();
          },
        },
        {
          buttonText: this.$t("app.alert.delete"),
          className: "red",
          callback: (close) => {
            this.socket_delete_message({
              task_id: comment.task_id,
              chat_id: comment._id,
              user_id: this.getUserData._id,
              project_id: this.$route.params.project_id,
              comment,
            });
            close();
          },
        },
      ]);

      // this.show_popup_delete((delete_message_popup) => {
      //     this.socket_delete_message({
      //         task_id: comment.task_id,
      //         chat_id: comment._id,
      //         user_id: this.getUserData._id,
      //         project_id: this.$route.params.project_id,
      //         comment
      //     })
      // })
    },
    comment_delete_chat(comment) {
      const aws = new File();

      if (comment.files) {
        comment.files.forEach((e) => {
          this.setUserFileSize_minus(+e.size);
          if (
            e.ext.toLowerCase() == "png" ||
            e.ext.toLowerCase() == "jpg" ||
            e.ext.toLowerCase() == "jpeg"
          ) {
            if (e.imgWidth > 200) {
              let sizes = [200, "full"];
              sizes.forEach((size) => {
                const remove = aws.remove(
                  "Chats" +
                    "/" +
                    this.$route.params.chat_id +
                    "/" +
                    size +
                    "__" +
                    e._id +
                    "__" +
                    e.filename
                );
              });
            } else {
              const remove = aws.remove(
                "Chats" +
                  "/" +
                  this.$route.params.chat_id +
                  "/" +
                  e._id +
                  "__" +
                  e.filename
              );
            }
          } else {
            const remove = aws.remove(
              "Chats" +
                "/" +
                this.$route.params.chat_id +
                "/" +
                e._id +
                "__" +
                e.filename
            );
          }
        });
      }

      this.show_popup_delete(() => {
        this.$socket.emit(
          "IN_RemoveMessages",
          this.$route.params.chat_id,
          comment._id
        );
      });
    },
  },
  computed: {
    ...mapGetters([
      "getUserData",
      "getKnownUsers",
      "getTasks",
      "getComments",
      "getCompletedTasks",
      "getPlan",
    ]),
  },
};
</script>
